import { useTranslations } from "use-intl";

import { CheckIcon } from "@/components/appIcons";

export function UsedOffersFilter({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) {
  const t = useTranslations("shared.affiliates");

  return (
    <label className="group ml-auto inline-flex min-h-11 shrink-0 cursor-pointer items-center sm:min-h-10">
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.currentTarget.checked)}
        className="peer sr-only"
      />
      <span className="inline-flex items-center gap-2.5 rounded-sm py-2 text-sm font-medium text-muted-foreground transition-colors group-hover:text-foreground peer-checked:text-primary peer-focus-visible:ring-2 peer-focus-visible:ring-ring peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-background motion-reduce:transition-none">
        <span
          aria-hidden="true"
          className="flex size-4 shrink-0 items-center justify-center rounded border border-current"
        >
          <CheckIcon className={checked ? "text-xs" : "invisible text-xs"} />
        </span>
        {t("usedOnly")}
      </span>
    </label>
  );
}
